import classes from "./Footer.module.scss";
import { clsx } from "clsx";
import type { FooterProps } from "./FooterProps";
import { getAsset } from "@/utils/assets";
import { useTranslation } from "@/hooks/useTranslation";
import { Container } from "@/components/ui/Container";
import { Heading } from "../ui/Heading";

type FooterLink = {
  title: string;
  url: string;
};

const contactUs: FooterLink[] = [
  {
    title: "Visit our supporter help center",
    url: "https://msf.org.uk/supporter-help-centre",
  },
  {
    title: "Get in touch by email",
    url: "mailto:uk.fundraising@london.msf.org",
  },
  {
    title: "Get in touch by telephone",
    url: "tel:+442074046600",
  },
];

const otherWaysToGive: FooterLink[] = [
  {
    title: "Make a legacy payment",
    url: "https://msf.org.uk/give-your-will?utm_source=donate-funnel&utm_medium=referral&utm_campaign=legacy#legacy",
  },
  {
    title: "Download Direct Debit form",
    url: "https://msf.org.uk/sites/default/files/2021-06/MSF196%20DD%20Form_Cold_Online_AW%20V2%20210715.pdf",
  },
  {
    title: "Download donation form",
    url: "https://msf.org.uk/sites/default/files/MSF377%20A4%20One%20Off%20Donation%20Form_Cold_Online_AW01.pdf",
  },
];

export function Footer(props: FooterProps) {
  const { className } = props;

  const t = useTranslation("_common");

  return (
    <footer className={clsx(classes.footer, className)}>
      <Container maxWidth="lg">
        <div className={classes.footerRow}>
          <div>
            <h2 className={classes.heading}>{t("footer-title")}</h2>
            <p className={classes.text}>{t("footer-description")}</p>
          </div>

          <div>
            <Heading size="lg" as="h3">
              Contact us
            </Heading>
            <ul className={classes.list}>
              {contactUs.map((link) => (
                <li key={link.title}>
                  <a
                    href={link.url}
                    className={classes.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <Heading size="lg" as="h3">
              Other ways to give
            </Heading>
            <ul className={classes.list}>
              {otherWaysToGive.map((link) => (
                <li key={link.title}>
                  <a
                    href={link.url}
                    className={classes.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className={classes.secureLogos}>
            <img
              src={getAsset("/images/secure-and-payment-logos.svg")}
              alt=""
              width={2157}
              height={122}
            />
          </div>
        </div>
      </Container>
    </footer>
  );
}
